import React, { useEffect, useState } from 'react'
import { CgArrowLeft } from 'react-icons/cg'
import { GoLocation } from 'react-icons/go'
import { Link, useParams } from 'react-router-dom'
import About from './partials/About'
import Enrollement from './partials/Enrollement'
import { GrEdit } from 'react-icons/gr'
import { TRAINER_API_END_POINT, TRAINING_API_END_POINT } from '../../../../../utils/constant'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { isExpired } from '../../../../../utils/Func'


const Enrollments = () => {
  const { id, opt } = useParams()
  const [option, setOption] = useState(opt?.toString() || "1")
  const [postData, setPostData] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const {user} = useSelector(store=>store.user);

  useEffect(() => {
    const fetchPostData = async () => {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("user_id", 4);
        formDataToSend.append("training_id", id);
        const response = await axios.post(`${TRAINING_API_END_POINT}/trainer/${id}`, formDataToSend)
        setPostData(response.data)
        setLoading(false)
        console.log("hgh", response.data)
      } catch (err) {
        setError("Erreur lors du chargement des données", err)
        setLoading(false)
      }
    }
    fetchPostData()
  }, [id])
  

  if (loading) return <div className="fixed w-screen flex h-screen items-center justify-center bg-white/20 backdrop-blur-sm backdrop-filter">
  <div className="size-10 animate-spin rounded-full border-4 border-solid border-gray-700 border-t-transparent"></div>
</div>
  if (error) return <p>{error}</p>

  
  return (
    <div className='layout-1'>
          <Link to="/mira-formateur/formation" className="flex gap-2 items-center mb-4 text-primary-text text-sm">
            <CgArrowLeft/>
            <h1 className=''>Retour à la liste</h1>
          </Link>

          <h2 className='text-start mb-1 font-semibold text-xl flex items-start gap-x-2'>{postData?.title} 
            <div className={isExpired(postData?.registration_end_at) ? 
            'flex items-center gap-1 rounded-full border text-sm py-1 px-2 font-normal border-[#fd5d60] bg-[#fd5d60]/5 text-[#fd5d60] bg-[#e5daff]'
            :
            'flex items-center gap-1 rounded-full border text-sm py-1 px-2 font-normal border-[#3700c3] bg-[#3700c3]/5 text-[#3700c3] '}>
            <span className={
              isExpired(postData?.registration_end_at) ? 
              'w-2.5 h-2.5 rounded-full bg-[#fd5d60]'
            :
            'w-2.5 h-2.5 rounded-full bg-[#3700c3]'}>
            </span> {isExpired(postData?.registration_end_at) ? "Expirée" : "Disponible"}
            </div>
            <Link to={"/mira-formateur/formation/"+ id+"/modifier"} className='hover:bg-neutral-100 rounded-full p-1.5'>
              <GrEdit/>
            </Link>
        </h2>

        <div className="flex gap-1 items-center">
         
          <GoLocation/> {postData?.location}
        </div>


      <div className="border rounded-md grid grid-cols-2 md:grid-cols-4 gap-4 text-start mt-4 py-4 px-6">
      <div>
    <p className="text-sm text-primary-text">Type de formation</p>
    <p className="font-semibold text-sm">{postData?.type || "Non spécifié"}</p>
  </div>
  <div>
    <p className="text-sm text-primary-text">Référence</p>
    <p className="font-semibold text-sm">{postData?.reference || "Aucune"}</p>
  </div>
  <div>
    <p className="text-sm text-primary-text">Durée</p>
    <p className="font-semibold text-sm">
      {postData?.duration ? `${postData.duration} heures` : "Non spécifiée"}
    </p>
  </div>
  <div>
    <p className="text-sm text-primary-text">Frais</p>
    <p className="font-semibold text-sm">
      {postData?.fees ? `${postData.fees} Ariary` : "Gratuit"}
    </p>
  </div>
      </div>

        <div className="grid grid-cols-1  gap-4 text-sm">
            <div className="col-span-4 ">
                <div className="flex sticky top-0 border-b w-full my-4 text-sm bg-white pt-2">
                    <button onClick={()=>setOption("1")} className={" px-6 py-2 border-b-2 hover:text-primary-black " + (option === "2" ? "border-b-transparent text-primary-text font-normal" : "border-b-gray-950 text-primary-black font-bold")}>A propos</button>
                    <button onClick={()=>setOption("2")} className={" px-6 py-2 border-b-2 hover:text-primary-black " + (option === "1" ? "border-b-transparent text-primary-text font-normal" : "border-b-gray-950 text-primary-black font-bold")}>Etudiants ({postData?.enrolments?.length || 0})</button>
                </div>
            </div>
        </div>

        {option === "1" && <About item={postData}/>}
        {option === "2" && <Enrollement data={postData}/>}

    </div>
  )
}

export default Enrollments

// import { useState } from "react";

